<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Textarea from '$components/Form/Textarea.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const needTypeOptions = [
        'Nettoyage de bureaux',
        'Nettoyage après travaux / fin de chantier',
        'Nettoyage de locaux industriels ou d’usine',
        'Nettoyage de vitres ou façades',
        'Désinfection / décontamination',
        'Dératisation / désinsectisation',
        'Curage / vidange de fosses septiques',
        'Autre',
    ].map((v) => ({ label: v, value: v, key: v }));

    const frequencyOptions = [
        'Une seule fois',
        'Régulièrement (ex : hebdomadaire, mensuel)',
    ].map((v) => ({ label: v, value: v, key: v }));

    const surfaceAreaOptions = [
        `Moins de 100 m²`,
        `100 à 500 m²`,
        `500 à 2 000 m²`,
        `Plus de 2 000 m²`,
        `Je ne sais pas`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.nettoyageIndustriel.needType}
        class=""
        let:field
        let:id
        label={`Quel est votre besoin principal ?`}
        helpLabel="Maximum 3 choix"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            max={3}
            defaultClass="grid grid-cols-1 @[350px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={needTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.nettoyageIndustriel.frequency}
        class=""
        let:field
        let:id
        label={`À quelle fréquence souhaitez-vous ce service ?`}
    >
        <PrettyChoice
            {form}
            {id}
            {field}
            defaultClass="grid grid-cols-1 @[350px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={frequencyOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.nettoyageIndustriel.surfaceArea}
        class=""
        let:field
        let:id
        label={`Surface totale à nettoyer (en m² approximatif)`}
    >
        <PrettyChoice
            {form}
            {id}
            {field}
            defaultClass="grid grid-cols-1 @[300px]:grid-cols-2 @[370px]:grid-cols-3 gap-x-6 gap-y-0"
            choices={surfaceAreaOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin, soyez le plus précis dans votre demande de devis"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande de devis`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
